module.exports = __webpack_public_path__ + "img/wa4.be084790.jpg";